import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

@Component({
	selector: "ui-button",
	template: `
		<loading-indicator color="white" [running]="loading" [size]="20" />
		<button [disabled]="disabled || loading" (click)="action.next()">
			<span><ng-content /></span>
		</button>
	`,
	styleUrls: ["./button.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ButtonComponent {
	@Output() action = new EventEmitter<void>();
	@Input() disabled: boolean;
	@HostBinding("class.loading")
	@Input()
	loading: boolean;
}
